import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTillToLength = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 200,
	height: 90,
	viewBox: "0 0 200 90",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_2938_30453",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 200,
		height: 90,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 200,
			height: 90,
			fill: "#C4C4C4"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_2938_30453)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M97.8677 40.6125L108.545 40.6125L106.18 38.0508C106.018 37.875 105.927 37.6366 105.927 37.3879C105.927 37.1393 106.018 36.9009 106.18 36.725L106.793 36.061C106.874 35.9736 106.969 35.9042 107.075 35.8569C107.18 35.8096 107.293 35.7852 107.406 35.7852C107.52 35.7852 107.633 35.8096 107.738 35.8569C107.843 35.9042 107.939 35.9736 108.019 36.061L112.904 41.3559C113.066 41.5317 113.157 41.7702 113.157 42.0188C113.157 42.2674 113.066 42.5059 112.904 42.6817L108.017 47.9762C107.936 48.0636 107.841 48.133 107.735 48.1803C107.63 48.2276 107.517 48.252 107.404 48.252C107.29 48.252 107.177 48.2276 107.072 48.1803C106.966 48.133 106.871 48.0636 106.791 47.9762L106.178 47.3122C106.015 47.1363 105.924 46.8979 105.924 46.6493C105.924 46.4006 106.015 46.1622 106.178 45.9864L108.542 43.425L97.8677 43.425C97.6382 43.425 97.4181 43.3263 97.2558 43.1505C97.0935 42.9746 97.0023 42.7362 97.0023 42.4875L97.0023 41.55C97.0023 41.3014 97.0935 41.0629 97.2558 40.8871C97.4181 40.7113 97.6382 40.6125 97.8677 40.6125Z",
				fill: "#F6DCC4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M46.4999 32.4877C37.2084 32.4877 29.6269 28.8921 29.057 24.3159H29V65.2564C29 70.0776 36.8095 74.0001 46.5 74.0001C56.1905 74.0001 64 70.0776 64 65.2564V24.3159H63.943C63.3728 28.8921 55.7914 32.4877 46.4999 32.4877Z",
				fill: "#FDF1E6",
				stroke: "#A35705"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M46.5 32.4875C55.7915 32.4875 63.373 28.8919 63.9429 24.3158C63.9999 24.1523 63.9999 23.9072 63.9999 23.7438C64 18.9225 56.1905 15 46.5 15C36.8095 15 29 18.9225 29 23.7438C29 23.9072 29 24.1523 29.057 24.3158C29.627 28.8919 37.2085 32.4875 46.5 32.4875Z",
				fill: "#F6DCC4",
				stroke: "#A35705"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M171.513 44.4999C171.513 35.2084 175.108 27.6269 179.685 27.057L179.685 27L138.744 27C133.923 27 130 34.8095 130 44.5C130 54.1905 133.923 62 138.744 62L179.685 62L179.685 61.943C175.108 61.3728 171.513 53.7914 171.513 44.4999Z",
				fill: "#FDF1E6",
				stroke: "#A35705"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M171.512 44.5C171.512 53.7915 175.108 61.373 179.684 61.9429C179.848 61.9999 180.093 61.9999 180.256 61.9999C185.077 62 189 54.1905 189 44.5C189 34.8095 185.077 27 180.256 27C180.093 27 179.848 27 179.684 27.057C175.108 27.627 171.512 35.2085 171.512 44.5Z",
				fill: "#F6DCC4",
				stroke: "#A35705"
			})
		]
	})]
});
export default SvgTillToLength;
